var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home",staticStyle:{"margin-bottom":"51px !important","overflow":"scroll","margin-top":"-1px"}},[_c('search')],1)}
var staticRenderFns = []

export { render, staticRenderFns }